/**
 * @file DiscoveryShowcase.jsx
 * @description The provider experience on the ABA Case Finder page, as real screenshots (sample provider, invented
 *   agencies, no real people) in the shared ProductShowcase frame: find cases on the map, Best Matches, one case's
 *   "Your fit", a BCBA staff position (salary, caseload, billable hours, RBTs to supervise), and applications with the
 *   agency thread. Images in public/marketing/provider (WebP, 2x).
 * @module components/DiscoveryShowcase
 */
import ProductShowcase from "./ProductShowcase";
import { MapPinIcon, StarIcon, TargetIcon, BriefcaseIcon, MessageIcon } from "./Icons";

const shot = (id, Icon, file, phoneX = 0.18) => ({
  id, key: id, Icon, src: `/marketing/provider/${file}.webp`, w: 1960, h: 1225, fit: "cover", phoneX,
  labelKey: `discoveryShowcase.tab.${id}`, captionKey: `discoveryShowcase.caption.${id}`, altKey: `discoveryShowcase.alt.${id}`,
});

export const DISCOVERY_TABS = [
  shot("map", MapPinIcon, "find-cases", 0),
  shot("matches", StarIcon, "best-matches", 0.25),
  shot("fit", TargetIcon, "your-fit", 0.18),
  shot("position", BriefcaseIcon, "bcba-position", 0.18),
  shot("applications", MessageIcon, "applications", 0.5),
];

export default function DiscoveryShowcase({ isMobile, accent }) {
  return <ProductShowcase isMobile={isMobile} accent={accent} tabs={DISCOVERY_TABS} sampleTag testId="discovery-showcase" />;
}
